module.exports = __webpack_public_path__ + "media/rendering/renderingSlide4-8f0de862.png";